export class ReelWinPosition {
  public type: string;

  public positions: number[];
  public win: number;
  public winDouble: number;
  public symbolId: number | null;
  public multiplier: number = 1;
}
